export default [
  {
    path: '/student-score-delete-by-session',
    name: 'student-score-delete-by-session',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-score-delete-by-session/index.vue')
  },
  {
    path: '/student-score-delete-by-session/create',
    name: 'student-score-delete-by-session-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-score-delete-by-session/create.vue')
  }
]
